// extracted by mini-css-extract-plugin
export default {"main":"part-app-link_main_jyqad","underline":"part-app-link_underline_BU9y9"};